import { upperCaseFirst } from 'Util/StringUtils';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';
import { assignDriverDetailsToPassenger } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/PassengerDetail';
import { VehicleBookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/VehicleBookingWizardData';
import { PassengerBookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/PassengerBookingWizardData';
import { UserEntity } from 'Models/Entities';
import { isNotNullOrUndefined, stringIsEmpty } from 'Util/TypeGuards';

/**
 * Maps a selected UserEntity to BookingWizardData, handling logic for vehicle wizard data
 * and overriding driver details if applicable.
 */
export function mapCustomerToWizardData(
	currentData: BookingWizardData,
	selectedCustomer?: UserEntity,
): BookingWizardData {
	const newData = new BookingWizardData({ ...currentData });
	newData.userId = selectedCustomer?.id ?? '';

	// Do checks to prevent overriding already defined names and phone number
	if (newData.innerWizardData instanceof VehicleBookingWizardData && isNotNullOrUndefined(selectedCustomer)) {
		if (currentData.userId !== selectedCustomer?.id) {
			newData.innerWizardData.driverFirstName = upperCaseFirst((selectedCustomer?.firstName ?? '').toLowerCase());
			newData.innerWizardData.driverLastName = upperCaseFirst((selectedCustomer?.lastName ?? '').toLowerCase());
			newData.innerWizardData.driverPhone = selectedCustomer?.phone ?? '';
			newData.innerWizardData.cargoIdentification = undefined;
			newData.innerWizardData.cargoMake = undefined;
			newData.innerWizardData.cargoModel = undefined;
			newData.innerWizardData.cargoTypeId = undefined;
			newData.innerWizardData.vehicleLengthId = undefined;
		}
		if (stringIsEmpty(newData.innerWizardData.driverFirstName) || currentData.userId !== selectedCustomer?.id) {
			newData.innerWizardData.driverFirstName = upperCaseFirst((selectedCustomer?.firstName ?? '').toLowerCase());
		}
		if (stringIsEmpty(newData.innerWizardData.driverLastName) || currentData.userId !== selectedCustomer?.id) {
			newData.innerWizardData.driverLastName = upperCaseFirst((selectedCustomer?.lastName ?? '').toLowerCase());
		}
		if (stringIsEmpty(newData.innerWizardData.driverPhone) || currentData.userId !== selectedCustomer?.id) {
			newData.innerWizardData.driverPhone = selectedCustomer?.phone ?? '';
		}
		if (currentData.userId !== selectedCustomer?.id) {
			newData.innerWizardData.cargoIdentification = undefined;
		}
		newData.innerWizardData.customerEmail = selectedCustomer.email;
		assignDriverDetailsToPassenger(newData);
	}

	// "Name on booking" follows the customer. BookingDetailsTab pre-fills it only when it is BLANK, so
	// changing the customer left the previous customer's name on the booking — the field was already
	// populated, so nothing re-prefilled it. Reset it here and that pre-fill runs again for the new
	// customer (and clearing the customer clears the name, rather than stranding the old one).
	if (
		newData.innerWizardData instanceof PassengerBookingWizardData &&
		currentData.userId !== (selectedCustomer?.id ?? '')
	) {
		newData.innerWizardData.primaryFirstName = upperCaseFirst((selectedCustomer?.firstName ?? '').toLowerCase());
		newData.innerWizardData.primaryLastName = upperCaseFirst((selectedCustomer?.lastName ?? '').toLowerCase());
	}

	return newData;
}
